import React from 'react'
import shareStatus1 from '../../../assets/imgs/host/sharestatus1.png'
import shareStatus1Dimension from '../../../assets/imgs/host/sharestatus1.png?size'
import shareStatus2 from '../../../assets/imgs/host/sharestatus2.png'
import shareStatus2Dimension from '../../../assets/imgs/host/sharestatus2.png?size'
import shareStatus3 from '../../../assets/imgs/host/sharestatus3.png'
import shareStatus3Dimension from '../../../assets/imgs/host/sharestatus3.png?size'
import shareStatus4 from '../../../assets/imgs/host/sharestatus4.png'
import shareStatus4Dimension from '../../../assets/imgs/host/sharestatus4.png?size'
import {ScreenType} from '../../../config/constants'
import ResponsiveImg from '../../common/ResponsiveImg'
import styles from './ShareStatus.scss'

const ShareStatus = () => <>
  <div className={[styles.container].join(' ')}>
    <div className={[styles.space97].join(' ')}/>
    <div className="d-flex align-items-center flex-column">
      <h2 className={[styles.title].join(' ')}>ホストのシェア状況</h2>
      <div className={[styles.text].join(' ')}>
        実際にCarstayに車中泊スポット・キャンプ場を登録してから予約が入った方の収益事例です。<br />
        貸出状況は立地条件や設備により様々ですが、充実したオプションやホスピタリティあふれるサービスで受取額をUPされている方もいます。
      </div>
      {/* PC */}
      <div className={['d-flex row w-100 justify-content-xl-center'].join(' ')}>
        <div className={['col-xl-6 p-0'].join(' ')}>
          <div className={[styles.borderContainer, styles.mr12].join(' ')}>
            <div className={['row m-0 w-100', styles.p24].join(' ')}>
              <div className={styles.image}>
                <ResponsiveImg
                  url={shareStatus1}
                  caption="Host Merit 1"
                  dimension={shareStatus1Dimension}
                  scales={{[ScreenType.md]: 4}}
                />
              </div>
              <div className={styles.content}>
                <div className={[styles.cardTitle].join(' ')}>首都圏近郊の好立地、テントサウナやドッグラン付きのキャンプ場兼車中泊スポット、幅広い層に人気</div>
                <div style={{marginTop: 17}} className='d-flex'>
                  <div className="col-6 p-0 d-flex flex-column">
                    <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                    <span className={[styles.averageTextBold].join(' ')}> 16<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                  </div>
                  <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                    <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                    <span className={[styles.averageTextBold, styles.ml4].join(' ')}> ¥ 81,500<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                  </div>
                </div>
              </div>
              <div className={styles.hidden}>
                <div className={[styles.cardTitle].join(' ')}>首都圏近郊の好立地、テントサウナやドッグラン付きのキャンプ場兼車中泊スポット、幅広い層に人気</div>
              </div>
            </div>
            <div className={styles.spHidden}>
              <div style={{paddingBottom: 16, marginLeft: -2}} className='d-flex'>
                <div className="col-6 p-0 pl-3 d-flex flex-column">
                  <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                  <span className={[styles.averageTextBold].join(' ')}> 16<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                </div>
                <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                  <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                  <span className={[styles.averageTextBold].join(' ')}> ¥81,500<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={['col-xl-6 p-0'].join(' ')}>
          <div className={[styles.borderContainer, styles.ml12].join(' ')}>
            <div className={['d-flex row m-0 w-100', styles.p24].join(' ')}>
              <div className={styles.image}>
                <ResponsiveImg
                  url={shareStatus2}
                  caption="Host Merit 2"
                  dimension={shareStatus2Dimension}
                  scales={{[ScreenType.md]: 4}}
                />
              </div>
              <div className={styles.content}>
                <div className={[styles.cardTitle].join(' ')}>全国各地で運営の温泉旅館施設の駐車場、上質な温泉とお料理で合計1000台以上の来場がある人気スポットに</div>
                <div style={{marginTop: 17}} className='d-flex'>
                  <div className="col-6 p-0 d-flex flex-column">
                    <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                    <span className={[styles.averageTextBold].join(' ')}> 29<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                  </div>
                  <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                    <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                    <span className={[styles.averageTextBold].join(' ')}>￥96,835<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                  </div>
                </div>
              </div>
              <div className={styles.hidden}>
                <div className={[styles.cardTitle].join(' ')}>全国各地で運営の温泉旅館施設の駐車場、上質な温泉とお料理で合計1000台以上の来場がある人気スポットに</div>
              </div>
            </div>
            <div className={styles.spHidden}>
              <div style={{paddingBottom: 16, marginLeft: -2}} className='d-flex'>
                <div className="col-6 p-0 pl-3 d-flex flex-column">
                  <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                  <span className={[styles.averageTextBold].join(' ')}> 29<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                </div>
                <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                  <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                  <span style={{marginLeft: -1.5}} className={[styles.averageTextBold].join(' ')}>¥96,835<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={['d-flex row w-100 justify-content-xl-center'].join(' ')}>
        <div className={['col-xl-6 p-0'].join(' ')}>
          <div className={[styles.borderContainer, styles.mr12].join(' ')}>
            <div className={['d-flex row m-0 w-100', styles.p24].join(' ')}>
              <div className={styles.image}>
                <ResponsiveImg
                  url={shareStatus3}
                  caption="Host Merit 3"
                  dimension={shareStatus3Dimension}
                  scales={{[ScreenType.md]: 4}}
                />
              </div>
              <div className={styles.content}>
                <div className={[styles.cardTitle].join(' ')}>四季折々の収穫体験ができる施設の団体向け駐車場を車中泊スポットに、新たな集客につながりました</div>
                <div style={{marginTop: 17}} className='d-flex'>
                  <div className="col-6 p-0 d-flex flex-column">
                    <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                    <span className={[styles.averageTextBold].join(' ')}> 4<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                  </div>
                  <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                    <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                    <span className={[styles.averageTextBold, styles.ml4].join(' ')}> ¥ 6,600<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                  </div>
                </div>
              </div>
              <div className={styles.hidden}>
                <div className={[styles.cardTitle].join(' ')}>四季折々の収穫体験ができる施設の団体向け駐車場を車中泊スポットに、新たな集客につながりました</div>
              </div>
            </div>
            <div className={styles.spHidden}>
              <div style={{paddingBottom: 16, marginLeft: -2}} className='d-flex'>
                <div className="col-6 p-0 pl-3 d-flex flex-column">
                  <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                  <span className={[styles.averageTextBold].join(' ')}> 4<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                </div>
                <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                  <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                  <span className={[styles.averageTextBold, styles.ml4].join(' ')}> ¥ 6,600<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={['col-xl-6 p-0'].join(' ')}>
          <div className={[styles.borderContainer, styles.ml12].join(' ')}>
            <div className={['d-flex row m-0 w-100', styles.p24].join(' ')}>
              <div className={styles.image}>
                <ResponsiveImg
                  url={shareStatus4}
                  caption="Host Merit 4"
                  dimension={shareStatus4Dimension}
                  scales={{[ScreenType.md]: 4}}
                />
              </div>
              <div className={styles.content}>
                <div className={[styles.cardTitle].join(' ')}>田舎暮らしや地域の特産品を味わえる体験と、ホスピタリティあふれるホストのおもてなしにリピーター続出</div>
                <div style={{marginTop: 17}} className='d-flex'>
                  <div className="col-6 p-0 d-flex flex-column">
                    <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                    <span className={[styles.averageTextBold].join(' ')}> 3<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                  </div>
                  <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                    <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                    <span className={[styles.averageTextBold, styles.ml4].join(' ')}> ¥ 5,100<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                  </div>
                </div>
              </div>
              <div className={styles.hidden}>
                <div className={[styles.cardTitle].join(' ')}>田舎暮らしや地域の特産品を味わえる体験と、ホスピタリティあふれるホストのおもてなしにリピーター続出</div>
              </div>
            </div>
            <div className={styles.spHidden}>
              <div style={{paddingBottom: 16, marginLeft: -2}} className='d-flex'>
                <div className="col-6 p-0 pl-3 d-flex flex-column">
                  <span className={[styles.averageText].join(' ')}>月平均予約日数</span>
                  <span className={[styles.averageTextBold].join(' ')}> 3<span className={[styles.averageTextUnit].join(' ')}>日/月</span></span>
                </div>
                <div className={['col-6 d-flex flex-column', styles.border].join(' ')}>
                  <span className={[styles.averageText].join(' ')}>月平均報酬額</span>
                  <span className={[styles.averageTextBold].join(' ')}> ¥5,100<span className={[styles.averageTextUnit].join(' ')}>/月</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className={['align-items-center', styles.note, styles.containerNote].join(' ')}>
    <p className="mb-0">※ 上記はあくまで目安です。月1回以上ゲストを迎え入れた実績がある人気スポット・キャンプ場の場合です（2022年4月現在）</p>
    <p className="mb-0">※ 売上はご自身で設定した1泊あたりの車中泊スポット・キャンプ場利用料とオプション、提供する体験によって異なります。飲食・宿泊施設などの提供サービスの売上は除きます。 </p>
  </div>
  <div className={[styles.space122].join(' ')}/>
</>
ShareStatus.displayName = 'ShareStatus'
export default ShareStatus
